import React, {useState,useEffect} from 'react';
import {Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import useStyles from './Styles';
import {Inc,Page,Item,Owner,PageNameLengthMax,PageNameLengthMin,PageGuideLengthMax} from './Inc';
import Ajax from './Ajax';
import InputString from './InputString';
import RowData from './RowData';
import DropImage from './DropImage';
import DropImageLight from './DropImageLight';
import Loading from './Loading';
import Yesno from './Yesno';
import Toast from './Toast';
import {Tools} from './Tools';
import StoreImg from './StoreImg';

interface PageInputProps {
    owner:Owner,
	managerId:number,
	pageId:number,
	isOpen:boolean,
	close(updated:boolean,pageId:number):void,
}

const PageInput = (props:PageInputProps)=> {
    Ajax.setEditorId(props.owner.owner_id);
	const classes = useStyles();

	const defItems:Item[] = [];
	const defStates = {
        page: Inc.defaultPage(),
        photo_ids: [] as number[],
        items: defItems,
		page_imgs: {} as { [key: string]: string; },
		page_item_ids: [] as number[],
        yesno: "",
		errors: [] as string[],
		hasError: false,
        notFound: false,
        isLoading: true,
    };
    const [states,setStates] = useState(defStates);
	const [toast,setToast] = useState('');

    const load = ()=>{
        Ajax.send("page/get",{page_id:props.pageId,mode:'edit'},(res:any)=>{
            //console.log(res);
            if( res.ok ){
				let hasError = false;
				let errors = [] as string[];
				if( !res.page.page_name || res.page.page_name==='' ){
					hasError = true;
					errors = ['page_name'];
				}

				setStates({
					page:Inc.convPage(res.page),
					items:res.param.items,
					photo_ids:res.param.photo_ids,
					page_imgs: {},
					page_item_ids: [],
					errors:errors,
					yesno:"",
					hasError:hasError,
					notFound:false,
					isLoading:false,
				});
            } else {
                setStates({...states,notFound:true});
            }
        });
    }

	const onChangeString = (name:keyof Page) => (value: string,hasError: boolean) => {
		//const item = {...states.item,[name]:value};
		validatePage({...states.page,[name]:value},name,hasError);
	};

	const validatePage = (page:Page,name:string,hasError:boolean)=>{
		let errors = [...states.errors];
		const index = errors.indexOf(name);
		if( index>=0 ){
			if(!hasError){
				errors.splice(index, 1);
			}
		} else {
			if(hasError){
				errors.push(name);
			}
		}
		setStates({...states,page:page,errors:errors,hasError:errors.length>0});
	}

	const changeImage = (id:string,src:string)=>{
		if (id.substring(0, 5) === "photo") {
			setStates(prev => {
				const page_imgs = { ...prev.page_imgs, [id]:src };
				let photo_ids = Tools.treatPhotos([ ...prev.photo_ids ],id,src,page_imgs,10);;
				return {
					...prev,
					photo_ids:photo_ids,
					page_imgs: page_imgs,
				};
			});
		} else {
			setStates(prev => {
				const page_imgs = { ...prev.page_imgs, [id]:src };
				return {
					...prev,
					page_imgs: page_imgs,
				};
			});
		}
	}

    const yes = ()=>{
        let page_id = 0;
        if( states.page.page_id && states.page.page_id>0 ){
            page_id = states.page.page_id;
        }
        setStates({...states,yesno:'',isLoading:true});
        Ajax.send("page/do",{page_id:page_id,manager_id:props.managerId,page:states.page,imgs:states.page_imgs,item_ids:states.page_item_ids},(res:any)=>{
            //console.log(res);
            if( res.ok ){
                //setStates({...states,yesno:'',isLoading:false});
				setStates(defStates);
				props.close(true,res.page_id);
            } else {
                setStates({...states,yesno:"",isLoading:false});
				setToast("登録できませんでした");
            }
        },(err:any)=>{
            setStates({...states,yesno:"",isLoading:false});
			setToast("登録できませんでした");
        });
    }
    const no = ()=>{
        setStates({...states,yesno:""});
    }
    const closeToast = ()=>{
		setToast("");
    }
    const reorder = (list:Item[], startIndex:number, endIndex:number) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const grid = 8;

    const getItemStyle = (isDragging:boolean, draggableStyle:any) => ({
        // some basic styles to make the items look a bit nicer
        userSelect: "none",
        padding: grid * 2,
        margin: `0 0 ${grid}px 0`,

        // change background colour if dragging
        background: isDragging ? "lightgreen" : "white",
        border: `1px solid #CCCCCC`,

        // styles we need to apply on draggables
        ...draggableStyle
    });

    const getListStyle = (isDraggingOver:boolean) => ({
        background: isDraggingOver ? "#EEEEFF" : "#EEEEEE",
        padding: 0,
        width: "100%"
    });

    const onDragEnd = (result:any)=>{
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const items = reorder(
            states.items,
            result.source.index,
            result.destination.index
        );

        const page_item_ids = new Array<number>(items.length).fill(0);
        
        for( let i=0 ; i<items.length ; i++ ){
            page_item_ids[i] = items[i].item_id;
        }
        setStates({...states,items:items,page_item_ids:page_item_ids});
    }
	const close = ()=>{
		setStates(defStates);
		props.close(false,0);
	}
    const confirm = ()=>{
        //console.log("states",states);
        //console.log("newImgs",newImgs);
        //console.log("errors",errors);
		if( states.hasError ){
			
		} else {
        	setStates({...states,yesno:"この内容で登録します。\nよろしいですか？"});
		}
    }

    useEffect( ()=>{
		if(!props.isOpen){
			return;
		}
        load();
		window.scrollTo(0,0);
    },[props.isOpen]);

    if( states.notFound ){
        return (
            <Redirect to="/"/>
        );
    }

	if( !props.isOpen ){
		return null;
	}

    if( states.isLoading ){
        return (
            <Loading isLoading={true}/>
        );
    }

    let page_id = "未定";
    if( states.page.page_id>0 ){
        page_id = String(states.page.page_id);
    }

	return (
		<Dialog
			fullScreen
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
		>
			<DialogContent style={{padding:"0",margin:"0",backgroundColor:'#F5F5F5'}}>

				<AppBar position="fixed" style={{backgroundColor:`#FFFFFF`}}>
					<Toolbar variant="dense" style={{backgroundColor:`#FFFFFF`}}>
						<div style={{color:'#333333',flex:'1'}}><ShoppingCartIcon style={{verticalAlign:'middle',marginRight:'0.25em'}}/><span style={{verticalAlign:'middle'}}>シリーズ編集</span></div>
						<Button variant="text" color="primary" onClick={close} style={{marginRight:`0.5em`}}>もどる</Button>
						<Button variant="contained" color="primary" disabled={states.hasError} onClick={confirm}>登録</Button>
					</Toolbar>
				</AppBar>

				<div style={{maxWidth:'1280px',width:'100%',boxSizing:'border-box',padding:"4em 1em",margin:'0 auto',backgroundColor:'#FFFFFF'}}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={3} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<Typography variant="h6">シリーズ名<span className="formRequired">必須</span></Typography>
							<div className="formExplanation">
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<InputString label="シリーズ名" required={true} value={states.page.page_name} onChange={onChangeString("page_name")} helper={PageNameLengthMin+'文字以上'+PageNameLengthMax+'文字以内'} opt={{minLength:PageNameLengthMin,maxLength:PageNameLengthMax}}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>

						<Grid item xs={12} sm={3} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<Typography variant="h6">シリーズ画像</Typography>
							<div className="formExplanation">
								シリーズのメインの画像です。<br/>
								幅1280pxあるとキレイに表示されます。<br/>
								<div className="formHint">
									※PNG/JPEG/GIFでJPEGに変換して保存されます<br/>
									※1280pxより大きい場合は自動的に縮小されます<br/>
								</div>
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<div style={{textAlign:"center",marginBottom:"1em"}}>
                                <DropImage noHelper={true} owner_id={props.owner.owner_id} data={states.page_imgs["img"]} img_id={states.page.img_id} id="img" change={changeImage}/>
							</div>
							<div className="formHelper">
							画像を登録するには「ここに追加」をクリックもしくは画像をドラッグして下さい
							</div>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>

						<Grid item xs={12} sm={3} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<Typography variant="h6">シリーズの紹介文</Typography>
							<div className="formExplanation">
								シリーズの内容やこのシリーズに含まれる商品の説明をなるべくわかりやすく書いてください
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<InputString label="シリーズの紹介文" required={false} value={states.page.page_guide} onChange={onChangeString("page_guide")} helper={Tools.comma(PageGuideLengthMax)+'文字以内'} opt={{rows:10,maxLength:PageGuideLengthMax}}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>

						<Grid item xs={12} sm={3} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<Typography variant="h6">追加画像</Typography>
							<div className="formExplanation">
								シリーズの紹介文の後に表示される画像です。<br/>
								<div className="formHint">
									※PNG/JPEG/GIFで、10枚まで登録できます<br/>
									※JPEGに変換して保存されます<br/>
									※幅1280px高さ1800pxより大きい場合は自動縮小されます<br/>
								</div>
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
								{states.photo_ids.map((img_id:number,index:number)=>{
									const key = "photo"+String(index+1);
									const name = "追加画像" + String(index+1);
									return (
										<div key={key} style={{ flex: '0 0 auto', width: '100px', height: '75px' }}>
											<DropImageLight noHelper={true} owner_id={props.owner.owner_id} data={states.page_imgs[key]} img_id={img_id} name={name} id={key} change={changeImage}/>
										</div>
									);
								})}
							</div>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>


						<Grid item xs={12} sm={3} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<Typography variant="h6">商品の並び</Typography>
							<div className="formExplanation">
								同じシリーズの商品を一覧表示する場合の順番を設定できます
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<FormControl fullWidth={true}>
								<DragDropContext onDragEnd={onDragEnd}>
									<Droppable droppableId="droppable">
										{(provided, snapshot) => (
											<div
												{...provided.droppableProps}
												ref={provided.innerRef}
												style={getListStyle(snapshot.isDraggingOver)}
											>
												{states.items.map((item, index) => {
													const key = "item"+index;
													return (
														<Draggable key={key} draggableId={key} index={index}>
															{(provided, snapshot) => (
																<div
																	ref={provided.innerRef}
																	{...provided.draggableProps}
																	{...provided.dragHandleProps}
																	style={getItemStyle(
																		snapshot.isDragging,
																		provided.draggableProps.style
																	)}
																>
																	<div style={{position:"relative"}}>
																		<div style={{marginLeft:"70px",minHeight:"50px",lineHeight:"1em"}}>
																			<div style={{marginBottom:'0.5em'}}>{item.item_name}</div>
																			<span className={classes.itemId}>ID:{item.item_id}</span>
																		</div>
																		<div style={{position:"absolute",left:"0",top:"0"}}>
																			<StoreImg owner_id={props.owner.owner_id} img_id={item.img_id} thumb={true} className="imgItemThumbSmall"/>
																		</div>
																	</div>
																</div>
															)}
														</Draggable>
													)}
												)}
												{provided.placeholder}
											</div>
										)}
									</Droppable>
								</DragDropContext>

								{states.items.length===0 ? (
									<div style={{padding:"0",marginBottom:"1em",color:"pink",fontSize:'90%'}}>※このシリーズの商品はまだありません</div>
								):(
									<FormHelperText>※ドラッグ＆ドロップで順序を変更できます</FormHelperText>
								)}

							</FormControl>

						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>

					</Grid>
					<div style={{maxWidth:'300px',marginLeft:'auto',marginTop:'2em',backgroundColor:'#F0F0F0',padding:'1em',boxSizing:'border-box'}}>
						<RowData name="シリーズID" value={page_id} height={true}/>
						<RowData name="商品数" value={String(states.page.num_item)} height={true}/>
						<RowData name="状態" value={states.page.status_label} height={true}/>
					</div>
				</div>
			</DialogContent>
            <Yesno mes={states.yesno} yes={yes} no={no} isOpen={states.yesno!==""}/>
            <Toast mes={toast} close={closeToast}/>
		</Dialog>
	);
}

export default PageInput;
